import { ReactNode } from "react";

/**
 * Highlight occurrences of `query` inside `text`.
 * Case-insensitive, escapes regex special chars, returns plain text when
 * the query is empty or no match is found.
 */
export function highlightMatch(text: string | null | undefined, query: string | null | undefined): ReactNode {
  const value = text ?? "";
  const q = (query ?? "").trim();
  if (!value || !q) return value;

  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`(${escaped})`, "ig");
  const parts = value.split(re);
  if (parts.length === 1) return value;

  const lowerQ = q.toLowerCase();
  return parts.map((part, i) =>
    part.toLowerCase() === lowerQ
      ? (
        <mark
          key={i}
          className="rounded-sm bg-primary/20 text-foreground px-0.5"
        >
          {part}
        </mark>
      )
      : <span key={i}>{part}</span>
  );
}
